import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import getSiteSettings from './getSiteSettings.graphql';


import SiteSettingsForm from '../../../components/SiteAdmin/SiteSettingsForm';
import Loader from '../../../components/Common/Loader/Loader';

import { injectIntl } from 'react-intl';

function SiteSettings({ intl: { formatMessage } }) {

  const { data, loading, refetch } = useQuery(getSiteSettings, {
    variables: { type: 'site_settings' },
    fetchPolicy: 'network-only',
    ssr: false,
  });

  const siteSettings = data?.getSiteSettings || {};

  const siteSettingsCollection = useMemo(() => {
    const settings = {};
    if (siteSettings.results?.length > 0) {
      siteSettings.results.forEach(item => {
        settings[item.name] = item.value;
      });
    }
    return settings;
  }, [siteSettings]);

  return (
    <Loader type="page" show={loading}>
      {!loading && (
        <SiteSettingsForm
          refetch={refetch}
          getSiteSettings={siteSettings}
          initialValues={siteSettingsCollection}
        />
      )}
    </Loader>
  );
}

export default injectIntl(SiteSettings);
